import Title from '@/components/content/common/Title'
import { convertLexicalToString } from '@/lib/utils'
import { Icon } from '@/icons/Icon'
import type { Block } from '@/types/app'
import type { Page } from '@/payload-types'

type GridTemplate = Extract<NonNullable<Page['layout']>[number], { blockType: 'gridTemplate' }>
type FaqTemplate = Extract<NonNullable<Page['layout']>[number], { blockType: 'faqTemplate' }>
type TitleData = GridTemplate['title'] | FaqTemplate['title']

type TitleBlockProps = {
  title: TitleData
  props?: any
}

export default function TitleBlock({ title, props }: TitleBlockProps) {
  const theme = props && props.theme ? props.theme : undefined

  const headingString = convertLexicalToString(
    (title?.heading?.root?.children ?? []) as Block[],
    theme,
  )
  const copyString = title?.copy?.root?.children
    ? convertLexicalToString(title?.copy?.root?.children as Block[], theme)
    : ''

  const titleTag = title?.heading?.root?.children?.[0]?.tag
  const tag = titleTag ?? 'h1'

  return (
    <Title
      title={headingString}
      paragraphs={copyString ? [copyString] : []}
      buttons={title?.buttons?.map((btn) => ({ label: btn.label, link: btn.url }))}
      subtitle={title?.subtitle}
      icon={title?.icon ? <Icon name={title.icon} className="text-primary-500" /> : null}
      type="primary"
      tag={tag}
      {...props}
    />
  )
}
